import {Base} from './Base';
import {rafThrottle} from '../../utilities/functions';
import cookies from '../../constants/cookies';
import Cookies from 'js-cookie';
import anime from 'animejs';

const SESSION_STORAGE_KEY = 'newsletterWidgetMinimized';

export class NewsletterWidget extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);

    this.footerRef = document.querySelector('footer.footer');
    this.teaser = this.refs.teaser;
    this.modal = this.refs.modal;

    this.isShown = false;

    // this.wasDismissed = !!sessionStorage.getItem(SESSION_STORAGE_KEY);

    this.isMinimized = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY) || false);

    this.userSignedUp = !!Cookies.get(cookies.NEWSLETTER_SIGNED_UP);

    if (!this.userSignedUp) {
      this.init();
    }
  }

  init() {
    const { submitButton, modalHeader, teaser } = this.refs;

    modalHeader.addEventListener('click', this.minimizeWidget);
    teaser.addEventListener('click', this.maximizeWidget);
    submitButton.addEventListener('click', this.handleSubmit);
    window.addEventListener('scroll', this.throttledHandleScroll, { passive: true });

    if(this.isMinimized) {
      this.showTeaser();
    }
  }

  handleSubmit = (e) => {
    const formSubmit = e.target.parentElement.querySelector('form [type="submit"]');
    if (formSubmit) formSubmit.click(); // trigger a click instead of submit() to keep html5 validation
  };

  handleScroll = (e) => {
    if (this.footerRef) {
      const pixels = this.pixelsVisible(this.footerRef);
      if (pixels > 0 && !this.isShown && !this.isMinimized) {
        this.showWidget();
      }
      if (this.isShown || this.isMinimized) {
        this.element.style.transform = `translateY(-${pixels}px)`;
      }
    }
  };

  throttledHandleScroll = rafThrottle(this.handleScroll);

  minimizeWidget = () => {
    //SHOW TEASER
    //HIDE MODAL
    this.isShown = false;
    this.showElement(this.teaser, this.setMinimizedState);
    this.hideElement(this.modal);
  }

  maximizeWidget = () => {
    //SHOW MODAL
    //HIDE TEASER
    this.isShown = true;
    this.showElement(this.modal, this.setMinimizedState);
    this.hideElement(this.teaser);
  }

  showWidget = () => {
    //SHOW MODAL
    this.isShown = true;
    this.showElement(this.modal);
  }

  hideWidget = () => {
    //Hide modal
    //Hide teaser
    this.isShown = false;
  }

  showTeaser = () => {
    //Show teaser
    this.showElement(this.teaser);
  }

  setMinimizedState = () => {
    this.isMinimized = !this.isMinimized;
    sessionStorage.setItem(SESSION_STORAGE_KEY, this.isMinimized);
  }

  showElement = (elem, callback) => {
    anime({
      targets: elem,
      opacity: [0, 1],
      marginBottom: [-60, 0],
      duration: 750,
      easing: 'cubicBezier(0.47, 0.32, 0.29, 1.01)',
      begin: () => {
        elem.style.display = 'inline-block';
      },
      complete: () => {
        elem.style.display = 'inline-block'; // Needed as begin sometimes doesn't fire if page/tab isn't active
        if(callback) {
          callback();
        }
      }
    });
  }

  hideElement = (elem, callback) => {
    anime({
      targets: elem,
      opacity: [1, 0],
      marginBottom: [0, -60],
      duration: 750,
      easing: 'cubicBezier(0.47, 0.32, 0.29, 1.01)',
      complete: () => {
        elem.style.display = '';
        if(callback) {
          callback();
        }
      }
    });
  }

  destroy = () => {
    //Not used ATM, should be used by a "Close" function
    this.footerRef = null;
    window.removeEventListener('scroll', this.throttledHandleScroll, { passive: true });
  };

  pixelsVisible = (element) => {
    const rect = element.getBoundingClientRect();

    // IE8 does not have window.innerHeight
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    // The element is below the viewport
    if (rect.top >= windowHeight) {
      return 0;
    }

    if (rect.top <= 0) {
      // The top of the node is at or above the top of the viewport,
      // so the top plus its height would be how much is shown.
      // However, we never want to provide a negative number for amount visible.
      const visible = Math.max(rect.top + element.offsetHeight, 0);

      // Never return more then the window height
      return Math.min(visible, windowHeight);
    }

    // We can determine the maximum possible amount visible rather easily,
    // by determining how much distance there is between the top of the bounding
    // rectangle and the viewport's height. However, if this is larger than our
    // DOM node, we don't want to report more visible than the node's full height
    return Math.min(windowHeight - rect.top, element.offsetHeight);
  };
}
